import type { CreativeContextSelection } from './creative-library';

/** The choice fields of a quote's or an image's summary. Absent on quotes saved before the card held them. */
export interface CreativeSelectionSummary {
  brandToken?: string | null;
  subjectToken?: string | null;
  productToken?: string | null;
  boardToken?: string | null;
  pinnedTokens?: Array<string> | null;
  referenceTokens?: Array<string> | null;
  intendedUse?: 'internal' | 'external' | null;
  channel?: string | null;
}

/**
 * What the card starts from: the choices a quote or an image was built with. The references are
 * every image it renders, the model's picks too, so the user can take any of them off.
 */
export function creativeSelectionFromSummary(summary: CreativeSelectionSummary | null | undefined): CreativeContextSelection {
  return {
    brandProfileToken: summary?.brandToken ?? null,
    subjectToken: summary?.subjectToken ?? null,
    productToken: summary?.productToken ?? null,
    boardToken: summary?.boardToken ?? null,
    referenceTokens: [...new Set([...(summary?.pinnedTokens ?? []), ...(summary?.referenceTokens ?? [])])],
    intendedUse: summary?.intendedUse ?? 'internal',
    channel: summary?.channel ?? null,
  };
}

function comparableSelection(selection: CreativeContextSelection): string {
  return JSON.stringify([
    selection.brandProfileToken ?? null,
    selection.subjectToken ?? null,
    selection.productToken ?? null,
    selection.boardToken ?? null,
    [...(selection.referenceTokens ?? [])].sort(),
    selection.intendedUse ?? 'internal',
    selection.channel ?? null,
  ]);
}

export function sameCreativeSelection(a: CreativeContextSelection, b: CreativeContextSelection): boolean {
  return comparableSelection(a) === comparableSelection(b);
}
